import MobileDetect from 'mobile-detect';
import * as types from '../mutation-types';

const device = () => {
  const detector = new MobileDetect(window.navigator.userAgent);
  return detector;
};

// initial state
const state = {
  page: {},
  pageLoaded: false,
  pageReady: false,
  lang: 'en',
  menuExpanded: false,
  currentPage: 'home',
  currentTab: 'company',
  currentPerson: '',
  currentProject: '',
  currentArticleIndex: '',
  pageIsAutoScrolling: false,
  popupOpened: false,
  fader: false,
  isErrorPage: false,
  mobile: device().mobile(),
};

// getters
const getters = {
  page: stateFreezed => stateFreezed.page,
  pageLoaded: stateFreezed => stateFreezed.pageLoaded,
  pageReady: stateFreezed => stateFreezed.pageReady,
  lang: stateFreezed => stateFreezed.lang,
  menuExpanded: stateFreezed => stateFreezed.menuExpanded,
  currentPage: stateFreezed => stateFreezed.currentPage,
  currentTab: stateFreezed => stateFreezed.currentTab,
  currentPerson: stateFreezed => stateFreezed.currentPerson,
  currentProject: stateFreezed => stateFreezed.currentProject,
  currentArticleIndex: stateFreezed => stateFreezed.currentArticleIndex,
  pageIsAutoScrolling: stateFreezed => stateFreezed.pageIsAutoScrolling,
  popupOpened: stateFreezed => stateFreezed.popupOpened,
  fader: stateFreezed => stateFreezed.fader,
  isErrorPage: stateFreezed => stateFreezed.isErrorPage,
  mobile: stateFreezed => stateFreezed.mobile,
};

// actions
const actions = {
  fetchPage({ commit }, params) {
    params.$http.get(`/${params.lang}/pages/`)
    .then((response) => {
      // get body data
      commit(types.RECEIVE_PAGE, response.body.content);
    });
  },
};

// mutations
const mutations = {
  [types.RECEIVE_PAGE](stateFreezed, pageFetched) {
    const st = stateFreezed;
    st.page = pageFetched;
  },
  [types.LOADED_PAGE](stateFreezed, loaded) {
    const st = stateFreezed;
    st.pageLoaded = loaded;
  },
  [types.READY_PAGE](stateFreezed, ready) {
    const st = stateFreezed;
    st.pageReady = ready;
  },
  [types.SET_LANG](stateFreezed, lang) {
    const st = stateFreezed;
    st.lang = lang;
  },
  [types.PAGE_IS_AUTO_SCROLLING](stateFreezed, scroll) {
    const st = stateFreezed;
    st.pageIsAutoScrolling = scroll;
  },
  [types.CHANGE_MENU_STATE](stateFreezed, menuState) {
    const st = stateFreezed;
    st.menuExpanded = menuState;
  },
  [types.SET_CURRENT_PAGE](stateFreezed, current) {
    const st = stateFreezed;
    // const currentTitle = current.replace('-content', '');
    // const currentTitleCapitalized = currentTitle.charAt(0).toUpperCase() + currentTitle.slice(1);
    // document.title = currentTitleCapitalized;
    st.currentPage = current;
  },
  [types.SET_CURRENT_TAB](stateFreezed, current) {
    const st = stateFreezed;
    st.currentTab = current;
  },
  [types.SET_CURRENT_PERSON](stateFreezed, current) {
    const st = stateFreezed;
    st.currentPerson = current;
  },
  [types.SET_CURRENT_PROJECT](stateFreezed, current) {
    const st = stateFreezed;
    st.currentProject = current;
  },
  [types.SET_CURRENT_ARTICLE](stateFreezed, current) {
    const st = stateFreezed;
    st.currentArticleIndex = current;
  },
  [types.SET_POPUP_STATE](stateFreezed, popupState) {
    const st = stateFreezed;
    st.popupOpened = popupState;
  },
  [types.SET_ERROR_PAGE_STATE](stateFreezed, errorState) {
    const st = stateFreezed;
    st.isErrorPage = errorState;
  },
  [types.SET_FADER](stateFreezed, faderState) {
    const st = stateFreezed;
    document.body.className = faderState ? 'with-overflow-hidden' : '';
    st.fader = faderState;
  },
  [types.IS_MOBILE](stateFreezed, isMobile) {
    const st = stateFreezed;
    st.mobile = isMobile || device().mobile();
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/page.js